export default __webpack_public_path__ + "person-small.5d1e437fd383e971.svg";